import React, { useEffect } from 'react'
import { motion } from 'framer-motion'
import { Wrench, Shield, Users, CheckCircle } from 'lucide-react'

const ManufacturingStaffing = () => {
  const positions = [
    'Production Workers',
    'Quality Control Inspectors',
    'Maintenance Technicians',
    'Plant Managers',
    'Safety Coordinators',
    'Industrial Engineers'
  ]

  return (
    <div>
      <section className="bg-gradient-to-br from-primary-800 via-primary-700 to-teal-700 text-white py-16 md:py-20">
        <div className="container-max">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-3xl md:text-5xl font-bold text-white mb-4">Manufacturing Staffing</h1>
            <p className="text-lg md:text-xl text-primary-100">Skilled manufacturing professionals for operational excellence</p>
            <div className="w-20 h-1 bg-accent-500 mx-auto mt-6 rounded-full"></div>
          </div>
        </div>
      </section>

      <section className="section-padding">
        <div className="container-max">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold text-primary-800 mb-6">Manufacturing Excellence</h2>
              <p className="text-secondary-500 mb-6">We provide skilled manufacturing professionals who understand safety protocols, quality standards, and operational efficiency.</p>
              <ul className="space-y-3">
                {positions.map((position, index) => (
                  <li key={index} className="flex items-center">
                    <CheckCircle className="w-5 h-5 text-green-500 mr-3" />
                    <span className="text-secondary-600">{position}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <img src="/hero-services.jpg" alt="Manufacturing Staffing" className="rounded-lg shadow-xl w-full object-cover max-h-[28rem]" />
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default ManufacturingStaffing
